// The payroll wizard, keyed on its ?draft= param (PRD_InAppNotifications C9).
//
// ProcessPayroll loads a draft once per mount (its draftLoaded guard), and React
// does not remount a page when only the query string changes — the bell lives in
// AppLayout, outside the route. Keying on `draft` makes a new run a fresh mount, so
// a "Payroll rejected" click from inside the wizard shows that run instead of
// keeping the current one (or merging the rejected run into a half-built one).
// Side effect, accepted in C9: the side nav's "Process Payroll" link (no draft)
// clicked on a resumed run also opens a fresh wizard.

import React from "react";
import { useSearchParams } from "react-router-dom";
import ProcessPayroll from "./ProcessPayroll";

export const ProcessPayrollRoute = () => {
  const [searchParams] = useSearchParams();
  return <ProcessPayroll key={searchParams.get("draft") || "new"} />;
};
